import { css } from 'lit';
export const selectTokenHeaderStyle = css ``;
//# sourceMappingURL=select-token-header.style.js.map